import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './app/App';
import { AppProvider } from './context/AppContext';
import { AuthGate, AuthProvider } from './context/AuthContext';
import './styles/global.css';
import './styles/auth-gate.css';

registerSW({ immediate: true });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <AuthGate>
        <AppProvider>
          <App />
        </AppProvider>
      </AuthGate>
    </AuthProvider>
  </React.StrictMode>
);
